// Import path normalizers used for extension-based request classification.
// Example: `theme.css?v=1#x` normalizes to `theme.css` for kind detection.

// Build the normalized import path used for extension checks.
export function normalizeImportPath(request: string): string {
  const queryIndex = request.indexOf('?')
  const hashIndex = request.indexOf('#')
  const endIndex = pickMinPositive(queryIndex, hashIndex)
  const base = endIndex === -1 ? request : request.slice(0, endIndex)
  // Return the normalized request without query or hash suffixes.
  return base.trim().toLowerCase()
}

// Build the smallest non-negative index from two positions.
function pickMinPositive(left: number, right: number): number {
  // Check whether the left position is missing.
  if (left === -1) {
    // Return the right position when the left position is missing.
    return right
  } else if (right === -1) {
    // Return the left position when the right position is missing.
    return left
  } else {
    // Return the smaller non-negative position.
    return Math.min(left, right)
  }
}
